// 修复 ResizeObserver 警告被当作错误的问题（开发环境专用）
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (
        args[0] &&
        typeof args[0] === 'string' &&
        args[0].includes('ResizeObserver loop completed with undelivered notifications.')
    ) {
      // 忽略该警告，不打印也不抛出
      return;
    }
    originalConsoleError.apply(console, args);
  };
}
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// 1. Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLanguage } from '@fortawesome/free-solid-svg-icons'  // 导入具体图标
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(faLanguage, far, fas)  // 添加图标到库
// 2. Animate.css（全局引入）
import 'animate.css'
// element-plus

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 全局错误处理：捕获并忽略 ResizeObserver 错误
window.addEventListener('error', function(e) {
  if (e.message.includes('ResizeObserver') || 
      (e.error && e.error.message && e.error.message.includes('ResizeObserver'))) {
    // 忽略 ResizeObserver 错误
    e.preventDefault();
    e.stopPropagation();
    return true;
  }
});

const app = createApp(App)

// 注册全局组件
app.component('font-awesome-icon', FontAwesomeIcon)

// 使用插件并挂载应用
app.use(ElementPlus).use(store).use(router).use(i18n).mount('#app')
